import React, { useState } from 'react';

/**
 * CookieBar Component
 * Banner GDPR con informativa sull'uso dei cookie tecnici.
 * Visibile finché l'utente non accetta (consenso salvato in localStorage).
 */
export default function CookieBar() {
  const [visible, setVisible] = useState(!localStorage.getItem('cookieConsent'));

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-sm text-gray-600 text-center sm:text-left">
          Questo sito utilizza cookie tecnici per migliorare l&apos;esperienza di navigazione.{' '}
          <a
            href="https://www.semantorpro.com/cookie-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800 transition"
          >
            Cookie Policy
          </a>
        </p>
        <button
          onClick={handleAccept}
          className="flex-shrink-0 bg-blue-600 text-white text-sm font-medium px-5 py-2 rounded hover:bg-blue-700 transition"
        >
          Ho capito
        </button>
      </div>
    </div>
  );
}
